import { addResizeListener, removeResizeListener } from './utils/resize-event';
var creatorMap = {};

(function (r) {
  return r.keys().map(function (sourcePath) {
    var _sourcePath$split = sourcePath.split('/'),
        _ = _sourcePath$split[0],
        creatorType = _sourcePath$split[1];

    creatorMap[creatorType] = r(sourcePath)["default"];
  });
})(require.context('./creator', true, /index.js/)); // exclude setOption, resize


var METHOD_PROXY_MAP = ['group', 'getWidth', 'getHeight', 'getDom', 'getOption', 'dispatchAction', 'on', 'off', 'convertToPixel', 'convertFromPixel', 'containPixel', 'showLoading', 'hideLoading', 'getDataURL', 'getConnectedDataURL', 'appendData', 'clear', 'isDisposed', 'dispose'];
export default {
  name: 'PagodaCharts',
  props: {
    type: String,
    ratio: {
      type: Number,
      "default": 375 / 260
    },
    width: String,
    height: String,
    config: {
      type: Object
    },
    autoResize: {
      type: Boolean,
      "default": true
    }
  },
  computed: {
    chart: function chart() {
      var creator = creatorMap[this.type];
      return creator ? creator(this.config) : function (option) {
        return option;
      };
    }
  },
  mounted: function mounted() {
    this.resetCanvasSize();
    this.echarts = this.$options.echarts.init(this.$refs.canvas, 'pagoda-echarts-theme');
    this.proxyEchartMethodToInstance(this, this.echarts, METHOD_PROXY_MAP);
    this.bindResize();
  },
  activated: function activated() {
    this.bindResize();
  },
  deactivated: function deactivated() {
    this.unbindResize();
  },
  beforeDestroy: function beforeDestroy() {
    this.unbindResize();
  },
  methods: {
    proxyEchartMethodToInstance: function proxyEchartMethodToInstance(instance, echartInstance, methodsMap) {
      methodsMap.forEach(function (methodName) {
        if (!(methodName in instance)) {
          instance[methodName] = function () {
            if (methodName in echartInstance && typeof echartInstance[methodName] === 'function') {
              return echartInstance[methodName].apply(echartInstance, arguments);
            } else {
              console.error("pagoda-echart\uFF1Aechart\u5B9E\u4F8B\u4E0A\u6CA1\u6709" + methodName + "\u65B9\u6CD5");
            }
          };
        } else {
          console.error("pagoda-echart\uFF1A" + methodName + "\u65B9\u6CD5\u5DF2\u5B58\u5728\u5B9E\u4F8B\u4E0A");
        }
      });
    },
    bindResize: function bindResize() {
      if (this.autoResize && !this.binded) {
        addResizeListener(this.$el, this.handleResize);
        this.binded = true;
      }
    },
    unbindResize: function unbindResize() {
      if (this.autoResize && this.binded) {
        removeResizeListener(this.$el, this.handleResize);
        this.binded = false;
      }
    },
    setOption: function setOption(option, notMerge, lazyUpdate) {
      this.echarts.setOption(this.chart(option, this.echarts._theme), notMerge, lazyUpdate);
    },
    resetCanvasSize: function resetCanvasSize() {
      var canvas = this.$el;
      var width = canvas.clientWidth;
      var height = width / this.ratio;
      canvas.style.width = this.width;
      canvas.style.height = this.height || height + "px";
    },
    handleResize: function handleResize() {
      this.resetCanvasSize();
      this.echarts.resize();
    },
    resize: function resize() {
      this.handleResize();
    }
  },
  render: function render(h) {
    return h("div", {
      "class": "pagoda-charts",
      "style": "background-color: #fff;",
      "ref": "canvas"
    });
  }
};